import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import NAVIGATION_BAR_CONFIG from '../components/NavigationBar/navigationBarConfig';
import routes from '../consts/routes';
import {selectIsAnyRenderedPopup} from '../state/selectors/modal';
import {selectIsUwmFullScreenRequired} from '../state/selectors/session';

const EXCLUDED_PAGES = [routes.RETAIL_REWARDS, routes.AI_ASSISTANT_TEST];

export const useIsNavigationBarRoute = () => {
    const {pathname} = useLocation();
    const navigationBarRoutes = NAVIGATION_BAR_CONFIG.filter((x) => x?.route).map((x) => x?.route);

    return [...navigationBarRoutes, ...EXCLUDED_PAGES].includes(pathname);
};

const useIsNavigationBarVisible = () => {
    const isNavigationBarRoute = useIsNavigationBarRoute();
    const isAnyRenderedPopup = useSelector(selectIsAnyRenderedPopup);
    const isUwmFullScreenRequired = useSelector(selectIsUwmFullScreenRequired);

    return isNavigationBarRoute && !isAnyRenderedPopup && !isUwmFullScreenRequired;
};

export default useIsNavigationBarVisible;
